// test2349
(2349 && 0);
